import {Component, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import { TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{

    layoutMode = 'slim';

    lightMenu = true;

    topbarColor = 'layout-topbar-blue';

    inlineUser = false;

    isRTL = false;

    inputStyle = 'outlined';

    ripple = true;
    constructor(private primengConfig: PrimeNGConfig,private translate: TranslateService) {
    }

    ngOnInit() {
        let currentLnaguage =  localStorage.getItem('lang');
        if(currentLnaguage == null){
            this.translate.use('en');
            this.isRTL = false; 
        }
        else{
            this.translate.use(currentLnaguage); 
            if(currentLnaguage == 'ar'){
                this.isRTL = true; 
            }else{
                this.isRTL = false; 
            }
        }
        this.primengConfig.ripple = true;
    }
  

}
